import React from 'react'
import { Modal } from '../../../../../../components/Modal/Modal'
import { useAppSelector } from '../../../../../../store/hooks'
import { selectAuthenticatedUser } from '../../../../../../store/auth/authSlice'

const SURVEY_URL = 'https://ljn4s9vaxf9.typeform.com/to/sDvDoI0S'

interface TranscriptSurveyModalProps {
  show: boolean
  onTakeSurvey: () => void
  onMaybeLater: () => void
}

export const TranscriptSurveyModal: React.FC<TranscriptSurveyModalProps> = ({ show, onTakeSurvey, onMaybeLater }) => {
  const authenticatedUser = useAppSelector(selectAuthenticatedUser)

  const handleTakeSurvey = () => {
    onTakeSurvey()
    const emailExtendedUrl = authenticatedUser ? `${SURVEY_URL}#email=${authenticatedUser.email}` : SURVEY_URL
    window.open(emailExtendedUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Modal
      show={show}
      onHide={onMaybeLater}
      centered
      header={<span className='fs-4 fw-bold'>Where do your transcripts end up?</span>}
      headerBodySeparator
      body={
        <p className='text-secondary my-3'>
          We&apos;re building a better way to bring your transcripts into the tools you already use. Tell us how. It only takes 2 minutes.
        </p>
      }
      showFooterActions
      footerSecondaryActionTitle='Maybe later'
      onFooterSecondaryAction={onMaybeLater}
      footerPrimaryActionTitle='Take survey'
      onFooterPrimaryAction={handleTakeSurvey}
    />
  )
}
